<template>
  <div class="device-stock">
    <div class="query-filter" v-if="isFilter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8">
            <div class="item" v-if="isCoJv && showSubsidiary">
              <div class="label">{{ $t('device_pending.zu_lin_fang') }}</div>
              <div class="value">
                <!-- orgType 总部:HQ 售后公司:SC 代理公司:JV 服务公司:SC,JV 大客户:CO 租赁方:CS -->
                <custom-select
                  url="OrganSelect"
                  :model="formSearch"
                  :params="{ childOrgType: 'CS' }"
                  v-model="formSearch.customerId"
                  :props="{ label: 'partnerName', value: 'partnerOrgId', map: { partnerName: 'orgName' } }"
                  :placeholder="$t('Common.com_please_select')"
                  @change="onPageChange({ page: 1 })"
                  filterable
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_location') }}</div>
              <div class="value">
                <custom-select
                  filterable
                  :listener="formSearch.customerId"
                  url="MyDeviceLocationTagSelect"
                  :model="formSearch"
                  v-model="formSearch.locationId"
                  :params="{ customerId: isCoJv ? (showSubsidiary ? formSearch.customerId : '') : userInfo.rootOrgId }"
                  :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName'} }"
                  :placeholder="$t('Common.com_please_select')"
                  @change="onPageChange({ page: 1 })"
                  theme="yellow"
                >
                </custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_site') }}</div>
              <div class="value">
                <custom-select
                  :auto="false"
                  :listener="formSearch.locationId || null"
                  url="locationSiteList"
                  :model="formSearch"
                  v-model="formSearch.siteId"
                  :params="{ locationId: formSearch.locationId }"
                  :props="{ label: 'siteName', value: 'siteId', map: { siteName: 'siteName' } }"
                  :placeholder="$t('Common.com_please_select')"
                  @change="onPageChange({ page: 1 })"
                >
                </custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('Common.com_model_no') }}</div>
              <div class="value">
                <custom-select
                  url="productCodeSelectList"
                  multiple
                  v-model="formSearch.productCode"
                  :props="{ label: 'productCode', value: 'productCode' }"
                  @change="onProductChange"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  theme="yellow"
                ></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_pending.ji_qi_zhuang_tai') }}</div>
              <div class="value">
                <custom-select code="dms_device_state_main_view" v-model="formSearch.mainState" @change="onMainStateChange" :placeholder="$t('Common.com_please_select')" width="100%" theme="yellow"></custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('device_pending.qi_ta_zhuang_tai') }}</div>
              <div class="value">
                <custom-select
                  code="dms_device_state_second_view"
                  multiple
                  v-model="formSearch.secondState"
                  @change="onSecondStateChange"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  theme="yellow"
                ></custom-select>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag
            v-if="formSearch.customerId"
            closable
            @close="
              formSearch.customerId = '';
              formSearch.orgName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.orgName }}
          </el-tag>
          <el-tag
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag
            v-if="formSearch.siteId"
            closable
            @close="
              formSearch.siteId = '';
              formSearch.siteName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.siteName }}
          </el-tag>
          <el-tag closable v-for="productTag in productTagList" :key="productTag.value" @close="onCloseTag(productTag.value, 'productTagList', 'productCode')">{{ productTag.label }}</el-tag>
          <el-tag closable v-for="mainStateTag in mainStateTagList" :key="mainStateTag.value" @close="onCloseTag(mainStateTag.value, 'mainStateTagList', 'mainState')">{{ mainStateTag.label }}</el-tag>
          <el-tag closable v-for="secondStateTag in secondStateTagList" :key="secondStateTag.value" @close="onCloseTag(secondStateTag.value, 'secondStateTagList', 'secondState')">
            {{ secondStateTag.label }}
          </el-tag>
          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>
    <!-- 在租 -->
    <div class="table-content">
      <div class="header">
        <div class="tab-box">
          <el-form :inline="true" @submit.native.prevent class="form-screen" style="display: flex">
            <el-tabs>
              <el-tab-pane :label="$t('device_pending.she_bei_lie_biao')" name="device"></el-tab-pane>
            </el-tabs>
            <el-form-item style="flex: 1; text-align: center; margin-bottom: 0">
              <div class="status-type">
                <ul>
                  <li class="item" :class="formSearch.state.includes('idle') ? 'active' : ''" @click="onStateChange('idle')">
                    <i class="point"></i>
                    <p>
                      {{ $t('device_pending.kong_xian') }}
                      <span>({{ countInfo.idle }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('using') ? 'active' : ''" @click="onStateChange('using')">
                    <i class="point success"></i>
                    <p>
                      {{ $t('device_pending.yun_xing_zhong') }}
                      <span>({{ countInfo.using }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('charging') ? 'active' : ''" @click="onStateChange('charging')">
                    <i class="point warning"></i>
                    <p>
                      {{ $t('device_pending.chong_dian_zhong') }}
                      <span>({{ countInfo.charging }})</span>
                    </p>
                  </li>
                  <li class="item" :class="formSearch.state.includes('offline') ? 'active' : ''" @click="onStateChange('offline')">
                    <i class="point info"></i>
                    <p>
                      {{ $t('device_pending.li_xian') }}
                      <span>({{ countInfo.offline }})</span>
                    </p>
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table-bd">
        <ul class="device-list" v-if="tableList.length > 0">
          <li class="li" v-for="item in tableList" :key="item.bodyNum" @click="onJumpDetails(item)">
            <div class="item">
              <div class="img-box" :class="{ gray: !getAttachUrl(item), offline: !item.isOnline }">
                <img :src="getAttachUrl(item)" alt="" />
              </div>
              <div class="info">
                <h3>{{ item.bodyNum }}</h3>
                <p class="tag">
                  <span v-if="item.productCode">{{ item.productCode }}</span>
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                  <span v-if="!formSearch.locationId && item.locationName">{{ item.locationName }}</span>
                  <span v-if="formSearch.locationId && item.siteName">{{ item.siteName }}</span>
                </p>
                <div class="state">
                  <div class="device-status-container" v-if="item.isOnline">
                    <ul class="device-status">
                      <!-- 电池 -->
                      <li class="battery" v-if="item.batteryCharge || item.batteryCharge === 0">
                        <div class="key">
                          <icon type="battery" :value="item.batteryCharge"></icon>
                        </div>
                        <div class="val">{{ item.batteryCharge || item.batteryCharge === 0 ? item.batteryCharge : '-' }}%</div>
                      </li>
                      <!-- 信号 -->
                      <li class="signal" v-if="(`${item.networkType}` === '1' && `${item.cellularMode}` === '1') || (`${item.networkType}` === '0' && `${item.cellularMode}` !== '1')">
                        <div class="key">
                          <!--
                            item.cellularMode
                              1-WIFI
                              2-2G
                              3-3G
                              4-4G
                          -->
                          <i v-if="`${item.networkType}` === '1' && `${item.cellularMode}` === '1'" class="icon-wifi-i" :class="wifi(item.wifiSignal)"></i>
                          <i v-else-if="`${item.networkType}` === '0' && `${item.cellularMode}` !== '1'" class="icon-signal-i" :class="signal(item.lteSignal)"></i>
                        </div>
                        <!--
                          networkType 和 cellularMode都为1显示
                          networkType 0和cellularMode不为1显示
                          其余不显示
                        -->
                        <div class="val" v-if="(`${item.networkType}` === '1' && `${item.cellularMode}` === '1') || (`${item.networkType}` === '0' && `${item.cellularMode}` !== '1')">
                          {{ getDicValue('dms_device_cellular_mode', item.cellularMode) || '-' }}
                        </div>
                        <!-- <div class="val">{{ item.networkType ? getDicValue('dms_device_network_type', item.networkType): '-' }}</div> -->
                      </li>
                      <!-- 温度 -->
                      <li class="temperature" v-if="item.batteryTemp || item.batteryTemp === 0">
                        <div class="key">
                          <!-- <i type="temperature" :value="item.batteryTemp"></i> -->
                          <icon type="temperature" :value="item.batteryTemp"></icon>
                        </div>
                        <div class="val">{{ $celsiusToFahrenheit(item.batteryTemp) }}{{ $formatTempUnit() }}</div>
                      </li>
                    </ul>
                  </div>
                  <div class="device-state">
                    <!-- {{statusList(item)}} -->
                    <div class="device-state-tag" v-for="(icon, index) in statusList(item)" :key="index" :class="{ 'has-name': icon.name }">
                      <i :class="icon.className"></i>
                      <!-- <span class="state-name">{{ item.name }}</span> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="point" :class="item.stateView"></div>
            </div>
          </li>
        </ul>
        <div class="no-data" v-else>{{ $t('Common.com_no_data') }}</div>
      </div>
      <div class="page-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange" radius></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import icon from '@/components/icon.vue';

export default {
  name: 'device_expired',
  components: { icon },
  props: {
    isFilter: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      formSearch: {
        type: '60',
        pageNum: 1,
        pageSize: 50,
        customerId: '',
        customerName: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        productCode: '',
        mainState: '',
        secondState: '',
        state: '',
        search: this.value,
        status: '',
        showSubsidiary: '',
      },

      productTagList: [],
      mainStateTagList: [],
      secondStateTagList: [],

      tableList: [],
      totalRows: 0,

      countInfo: {},
    };
  },
  mounted: function () {
    this.getFuncView(null, () => {});
    this.getTableList();
    this.getStatusCount();
  },
  methods: {
    signal(val) {
      if (val >= 100) {
        return 'signal-xinhao100';
      }
      if (val >= 75) {
        return 'signal-xinhao75';
      }
      if (val >= 50) {
        return 'signal-xinhao50';
      }
      return 'signal-xinhao25';
    },
    wifi(val) {
      if (val >= 100) {
        return 'wifi100';
      }
      if (val >= 66) {
        return 'wifi66';
      }
      return 'wifi33';
    },
    // 设备状态icon列表
    statusList(item) {
      if (Object.keys(item).length) {
        const ret = [];

        const { lockState, isOnline, isPowerSave } = item;
        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          // 显示锁机(自由锁1 账单锁2)
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock',
            });
          }
          // 故障
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault',
          //   });
          // }
          // 是否省电模式
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave',
            });
          }
        } else {
          // 设备多状态：可以同时存在多个的状态
          /** 设备多状态 start */

          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-suoji gray',
              dicCode: 'isLock',
            });
          }
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault',
          //   });
          // }

          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave',
            });
          }
          /** 设备多状态 end */
        }
        return ret;
      }
      return [];
    },
    // 获取数量统计
    getStatusCount() {
      this.$getJSON(apis.portalDeviceStatusCount, this.formSearch).then((res) => {
        const data = res.data;
        this.countInfo = data;
      });
    },
    // 产品型号
    onProductChange(data) {
      if (!data || !data.length) {
        this.productTagList = [];
      } else {
        this.productTagList = data.map(item => ({
          label: item.productCode,
          value: item.productCode,
          ...item,
        }));
      }
      this.onPageChange({ page: 1 });
    },
    // 机器状态
    onMainStateChange(data) {
      const mainStatenName = this.formSearch.mainState.trim();
      if (mainStatenName) {
        this.mainStateTagList = [
          {
            label: data.name,
            value: mainStatenName,
          },
        ];
      } else {
        this.mainStateTagList = [];
      }

      this.onPageChange({ page: 1 });
    },
    // 其他状态
    onSecondStateChange(data) {
      if (!data || !data.length) {
        this.secondStateTagList = [];
      } else {
        this.secondStateTagList = data.map(item => ({
          label: item.name,
          value: item.value,
          ...item,
        }));
      }
      this.onPageChange({ page: 1 });
    },
    // 删除筛选项
    onCloseTag(value, tagList, key) {
      // this.stateTagList = this.stateTagList.filter(item => item.value !== value);
      // this.formSearch.caseOrderState = this.stateTagList.map(item => item.value);
      this[tagList] = this[tagList].filter(item => item.value !== value);
      this.formSearch[key] = this[tagList].map(item => item.value);
      // console.log(this.formSearch[key],this[tagList])
      this.onPageChange({ page: 1 });
    },
    // 清空
    onClear() {
      this.customerTagList = [];
      this.locationTagList = [];
      this.siteTagList = [];
      this.productTagList = [];
      this.mainStateTagList = [];
      this.secondStateTagList = [];

      this.formSearch.customerId = '';
      this.formSearch.locationId = null;
      this.formSearch.siteId = '';
      this.formSearch.productCode = '';
      this.formSearch.mainState = '';
      this.formSearch.secondState = '';
      this.onPageChange({ page: 1 });
    },
    // 切换状态
    onStateChange(type) {
      if (this.formSearch.state.includes(type)) {
        this.formSearch.state = this.formSearch.state.filter(item => item !== type);
      } else {
        this.formSearch.state = [...this.formSearch.state, type];
      }
      // this.formSearch.state.push(type);
      this.onPageChange({ page: 1 });
    },
    // 设备分页列表
    getTableList() {
      //  const timezone = this.formSearch.timezone.join('/');
      // this.formSearch.onlineStartTime = this.formSearch.onlineTime && this.formSearch.onlineTime[0]
      //   ? this.formSearch.onlineTime[0]
      //   : undefined;
      // this.formSearch.onlineEndTime = this.formSearch.onlineTime && this.formSearch.onlineTime[1]
      //   ? this.formSearch.onlineTime[1]
      //   : undefined;
      // this.formSearch.cleanStartTime = this.formSearch.cleanTime && this.formSearch.cleanTime[0]
      //   ? this.formSearch.cleanTime[0]
      //   : undefined;
      // this.formSearch.cleanEndTime = this.formSearch.cleanTime && this.formSearch.cleanTime[1]
      //   ? this.formSearch.cleanTime[1]
      //   : undefined;
      this.formSearch.search = this.value;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.PortalDeviceAsmPage, this.formSearch).then(async (res) => {
        const deviceList = res.data.list || [];
        if (deviceList.length > 0) {
          const list = await this.formatAttachList(deviceList, 'productCodeId', 'dms.product.icon');
          this.tableList = list;
        } else {
          this.tableList = deviceList;
        }
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
      this.getStatusCount();
    },
    onExport() {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('PortalDeviceAsmExport', this.formSearch);
    },
    // 跳转详情
    onJumpDetails(item) {
      if (this.funcView.device_detail) {
        this.jump('/other/device/accountDeviceDetail', {
          bodyNum: item.bodyNum,
          deviceId: item.deviceId,
          // deviceId: '574295102570864640'
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
</style>
